import type { State } from '../common/types.tsx';

export const getVirtualisedItems = (state: State): State => state;
